var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 81 81",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.5 10.125h-54a3.375 3.375 0 00-3.375 3.375v54a3.375 3.375 0 003.375 3.375h54a3.375 3.375 0 003.375-3.375v-54a3.375 3.375 0 00-3.375-3.375zm-6.905 14.394l-3.26 3.122a.946.946 0 00-.358.915v22.953a.945.945 0 00.358.915l3.179 3.125v.689H44.513v-.689l3.297-3.2c.328-.323.328-.421.328-.914V32.879L38.97 56.153h-1.24L27.061 32.88v15.6a2.174 2.174 0 00.594 1.792l4.29 5.2v.686H19.78v-.685l4.29-5.201a2.086 2.086 0 00.553-1.793V30.442a1.58 1.58 0 00-.513-1.333l-3.814-4.59v-.685H32.13l9.146 20.058 8.04-20.058h11.282v.685h-.003z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/Medium.99cbe614496a4a95289fb0ef8220f3de.svg";
export { ForwardRef as ReactComponent };